// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__IWMbn","large":"styles_large__2R_4J"};